import React from 'react'

import { TabelaColuna } from 'src/componentes'
export const colunaDataOpcaoTCC = (): TabelaColuna => ({
  Chave: 'dataSolicitacao',
  ComOrdenacao: true,
  RenderizarCabecalho: () => <div style={{ width: 120 }}>Data Solicitação</div>
})
